'use strict';

/**
 *
 * @name: nsInfoBar
 *
 */

function NnInfoBarDirective() {

  'ngInject';

  return {
    template: `
      <div class="ns-info-bar">
        <div class="container">
          <div class="ns-ifo-bar-content" data-ng-transclude></div>
          <a class="close" data-ng-click="infobar.close()"></a>
        </div>
      </div>
    `,
    replace: true,
    transclude: true,
    scope: {
      position: '@position'
    },
    controller: NnInfoBarDirectiveController,
    controllerAs: 'infobar'
  };
}

function NnInfoBarDirectiveController(
  $scope,
  $localStorage
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var infobar = this;
  infobar.position = $scope.position || 'top';
  var HEADER_CLASS = 'info-bar-visible ' + 'info-bar-visible--' + infobar.position;

  /**
   *
   * @PUBLIC_METHODS
   *
   */

  infobar.close = function() {

    $('body').removeClass(HEADER_CLASS);
    $localStorage.infoBarClosedAt = new Date().getTime();
  };

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  function init() {

    if (_lastSeenLonEnough()) {

      $('body').addClass(HEADER_CLASS);
    }
  }

  function _lastSeenLonEnough() {

    return !$localStorage.infoBarClosedAt ? true : moment(JSON.parse($localStorage.infoBarClosedAt)).add(14, 'days') < new Date();
  }

  /**
   *
   * @INIT
   *
   */

  init();
}

export default NnInfoBarDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-info-bar.directive.js